// extracted by mini-css-extract-plugin
module.exports = {"ProductsOrderBadge":"ProductsOrderBadge_ProductsOrderBadge__1Qz15","statusManual":"ProductsOrderBadge_statusManual__Gxt9r"};